import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../componets/Loader";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import { IconButton } from "@mui/material";
import PrintReport from "../assets/SVGs/Report/PrintReport";
import { formatCurrency } from "../componets/helper";
import { ReportAPI } from "../api/report";

const GeneralClosedBusinessReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const startDate = dayjs(
        localStorage?.getItem("generalClosedBusinessReport"),
      ).format("YYYY-MM-DD");
      const endDate = dayjs()?.format("YYYY-MM-DD");

      const closedBusinessData = await ReportAPI.getCloseBusinessReport(
        startDate,
        endDate,
      );
      setData(closedBusinessData?.data);
    } catch (error) {
      const status = error.response?.status;
      if (status === 401) {
        navigate("/login");
      } else {
        console.error("Error fetching closed business report:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />
        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">General Closed Businesses Report</h1>
          <p className="header-date">
            {`${(() => {
              const storedDate = localStorage.getItem(
                "generalClosedBusinessReport",
              );

              const formattedStartDate = dayjs(storedDate).isValid()
                ? dayjs(storedDate).format("MM/DD/YYYY")
                : data?.at(-1)?.closed_business_date;

              return `${formattedStartDate} - ${dayjs().format("MM/DD/YYYY")}`;
            })()}`}
          </p>
          <p className="header-date">
            Total Realized Revenue :{" "}
            {formatCurrency(data?.total_realized_revenue)}
          </p>

          <IconButton
            sx={{
              border: "1px solid #AEBBCB",
              "@media print": {
                display: "none",
              },
            }}
            onClick={handlePrint}
            className="no-print"
          >
            <PrintReport className="no-print" />
          </IconButton>
        </div>
      </header>

      <div className="customTable active-member-roster-table">
        <table>
          <thead>
            <tr>
              <th>Closed Business Name</th>
              <th>Closed Business Date</th>
              <th>Dollar Amount of Realized Revenue</th>
              <th>Recurrent</th>
              <th>Period</th>
              <th>First Day of Payment</th>
              <th>Last Day of Payment</th>
              <th>Dollar Amount per Period</th>
            </tr>
          </thead>
          <tbody>
            {data && data.records.length > 0 ? (
              data?.records?.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                  }}
                >
                  <td>{row?.name ? row?.name : "N/A"}</td>
                  <td>
                    {row?.date ? dayjs(row?.date)?.format("MM/DD/YYYY") : "N/A"}
                  </td>
                  <td>
                    {row?.dollar_amount_of_realized_revenue
                      ? formatCurrency(row?.dollar_amount_of_realized_revenue)
                      : "N/A"}
                  </td>
                  <td>
                    {row?.recurrent !== null && row?.recurrent !== undefined
                      ? (row?.recurrent ? "Yes" : "No")
                      : "N/A"}
                  </td>
                  <td>
                    {row?.period ? row?.period?.charAt(0).toUpperCase() + row?.period?.slice(1) : "N/A"}
                  </td>
                  <td>
                    {row?.first_day_of_payment ? dayjs(row?.first_day_of_payment)?.format("MM/DD/YYYY") : "N/A"}
                  </td>
                  <td>
                    {row?.last_day_of_payment ? dayjs(row?.last_day_of_payment)?.format("MM/DD/YYYY") : "N/A"}
                  </td>
                  <td>
                    {row?.dollar_amount_per_period
                      ? formatCurrency(row?.dollar_amount_per_period)
                      : "N/A"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No Closed Businesses Available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GeneralClosedBusinessReport;
